import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-21528784"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-d-flex p-flex-wrap full-height p-align-start" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "p-mb-0 p-col-12 p-text-center p-text-uppercase" }, " Paramétrage de code barre ", -1))
const _hoisted_3 = { class: "p-field p-col-12 p-xl-6" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Hauteur", -1))
const _hoisted_5 = { class: "p-field p-col-12 p-xl-6" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Largeur", -1))
const _hoisted_7 = { class: "p-field p-col-12 p-xl-6" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "bar_column" }, "Nombre par lignes", -1))
const _hoisted_9 = { class: "p-field p-col-12 p-xl-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gap" }, "Ecart", -1))
const _hoisted_11 = { class: "p-field p-col-12 p-xl-6" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "quantity" }, "Quantité à générer", -1))
const _hoisted_13 = { class: "p-field p-col-12 p-xl-6" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "quantity" }, "Taille du titre", -1))
const _hoisted_15 = { class: "p-field p-col-12" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "Titre du code", -1))
const _hoisted_17 = { class: "p-field p-col-12" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Code barre", -1))
const _hoisted_19 = { class: "p-inputgroup" }
const _hoisted_20 = { class: "p-field p-col-12 p-mt-3" }
const _hoisted_21 = {
  style: {"max-height":"100%","overflow":"scroll"},
  class: "p-col-12 p-md-9 p-d-flex p-justify-center",
  id: "barcodes"
}
const _hoisted_22 = { class: "p-d-flex code-controls p-justify-center p-align-center" }
const _hoisted_23 = {
  key: 0,
  style: {"transform":"translateY(10px)","text-align":"center","font-weight":"600"}
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = ["height", "width", "src"]
const _hoisted_26 = { class: "p-field" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Titre", -1))
const _hoisted_28 = { class: "p-field p-mt-2" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Code barre", -1))
const _hoisted_30 = { class: "p-inputgroup" }
const _hoisted_31 = { class: "p-field p-mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_BlockUI = _resolveComponent("BlockUI")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _directive_badge = _resolveDirective("badge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)), ["prevent"])),
      class: "p-fluid p-col-12 p-md-3 p-d-flex p-flex-wrap p-p-0 form-settings",
      style: {"height":"100%","overflow":"scroll"}
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_InputNumber, {
          modelValue: _ctx.params.height,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.params.height) = $event)),
          id: "bar_height",
          showButtons: "",
          buttonLayout: "horizontal",
          decrementButtonClass: "p-button-secondary",
          incrementButtonClass: "p-button-secondary",
          incrementButtonIcon: "pi pi-plus",
          decrementButtonIcon: "pi pi-minus"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_InputNumber, {
          id: "bar_width",
          modelValue: _ctx.params.width,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.params.width) = $event)),
          showButtons: "",
          buttonLayout: "horizontal",
          decrementButtonClass: "p-button-secondary",
          incrementButtonClass: "p-button-secondary",
          incrementButtonIcon: "pi pi-plus",
          decrementButtonIcon: "pi pi-minus"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_component_InputNumber, {
          id: "bar_column",
          modelValue: _ctx.params.columns,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.params.columns) = $event)),
          "allow-empty": false,
          min: 1,
          showButtons: "",
          buttonLayout: "horizontal",
          decrementButtonClass: "p-button-secondary",
          incrementButtonClass: "p-button-secondary",
          incrementButtonIcon: "pi pi-plus",
          decrementButtonIcon: "pi pi-minus"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createVNode(_component_InputNumber, {
          id: "gap",
          modelValue: _ctx.params.gap,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.params.gap) = $event)),
          showButtons: "",
          buttonLayout: "horizontal",
          decrementButtonClass: "p-button-secondary",
          incrementButtonClass: "p-button-secondary",
          incrementButtonIcon: "pi pi-plus",
          decrementButtonIcon: "pi pi-minus"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_InputNumber, {
          id: "quantity",
          modelValue: _ctx.params.quantity,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.params.quantity) = $event)),
          showButtons: "",
          min: 1,
          "allow-empty": false,
          buttonLayout: "horizontal",
          decrementButtonClass: "p-button-secondary",
          incrementButtonClass: "p-button-secondary",
          incrementButtonIcon: "pi pi-plus",
          decrementButtonIcon: "pi pi-minus"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createVNode(_component_InputNumber, {
          id: "quantity",
          modelValue: _ctx.params.titleSize,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.params.titleSize) = $event)),
          showButtons: "",
          min: 1,
          "allow-empty": false,
          buttonLayout: "horizontal",
          decrementButtonClass: "p-button-secondary",
          incrementButtonClass: "p-button-secondary",
          incrementButtonIcon: "pi pi-plus",
          decrementButtonIcon: "pi pi-minus",
          suffix: "px"
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode(_component_InputText, {
          id: "title",
          modelValue: _ctx.params.title,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.params.title) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _hoisted_18,
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_Button, {
            icon: "pi pi-box",
            class: "p-inputgroup-addon p-button-secondary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.autoGenerateCode()))
          }),
          _createVNode(_component_InputText, {
            modelValue: _ctx.params.label,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.params.label) = $event)),
            type: "text"
          }, null, 8, ["modelValue"]),
          _createVNode(_component_Button, {
            icon: "pi pi-box",
            class: "p-inputgroup-addon p-button-secondary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.autoGenerateCode()))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_Button, {
          type: "submit",
          label: _ctx.$t('add'),
          "icon-pos": "right",
          icon: "pi pi-check-square",
          class: "p-button-secondary p-button-outlined"
        }, null, 8, ["label"])
      ])
    ], 32),
    _createElementVNode("span", _hoisted_21, [
      _createElementVNode("div", {
        style: _normalizeStyle(`display: inline-grid; grid-template-columns: repeat(${
          _ctx.params.columns
        }, 1fr);
        gap:${_ctx.params.gap * 0.75}px ${_ctx.params.gap}px;
        font-size: ${_ctx.params.titleSize}px`)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.codes, (code, index) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "code-container",
            key: index
          }, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_Button, {
                onClick: ($event: any) => (_ctx.openEdition($event, index)),
                icon: "pi pi-pencil",
                class: "p-button-sm p-mr-3"
              }, null, 8, ["onClick"]),
              _createVNode(_component_Button, {
                onClick: ($event: any) => (_ctx.removeCode(index)),
                icon: "pi pi-trash",
                class: "p-button-sm p-button-danger"
              }, null, 8, ["onClick"])
            ]),
            (code.title)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(code.title), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_24, " ")),
            _createElementVNode("img", {
              alt: "LOCAA BARCODE",
              height: _ctx.params.height,
              width: _ctx.params.width,
              src: code.image
            }, null, 8, _hoisted_25)
          ]))
        }), 128))
      ], 4)
    ]),
    _createVNode(_component_BlockUI, {
      blocked: !_ctx.codes.length,
      class: "controls-buttons p-d-inline-flex"
    }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", null, [
          _createVNode(_component_Button, {
            label: _ctx.$t('pos.print'),
            class: "p-button-info",
            icon: "pi pi-print",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.printBarcodes()))
          }, null, 8, ["label"])
        ])), [
          [
            _directive_badge,
            `${_ctx.codes.length}`,
            void 0,
            { primary: true }
          ]
        ]),
        _createVNode(_component_Button, {
          label: _ctx.$t('reset'),
          class: "p-button-warning p-ml-4",
          icon: "pi pi-times-circle",
          "icon-pos": "right",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.codes.length = 0))
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 8, ["blocked"]),
    _createVNode(_component_OverlayPanel, { ref: "opEdit" }, {
      default: _withCtx(() => [
        _createElementVNode("form", {
          onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveEdition && _ctx.saveEdition(...args)), ["prevent"])),
          class: "p-fluid"
        }, [
          _createElementVNode("div", _hoisted_26, [
            _hoisted_27,
            _createVNode(_component_InputText, {
              modelValue: _ctx.edit.title,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.edit.title) = $event)),
              type: "text"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createVNode(_component_InputText, {
                modelValue: _ctx.edit.label,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.edit.label) = $event)),
                type: "text"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Button, {
                icon: "pi pi-box",
                class: "p-inputgroup-addon p-button-secondary",
                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.autoGenerateCode()))
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createVNode(_component_Button, {
              icon: "pi pi-save",
              class: "p-button-success",
              type: "submit",
              label: _ctx.$t('submit')
            }, null, 8, ["label"])
          ])
        ], 32)
      ]),
      _: 1
    }, 512)
  ]))
}